"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcCustomRepetitionLabel = void 0;
const commaJoin_1 = __importDefault(require("@opsbase/lib-general/utils/commaJoin"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const CustomRepetitionType_1 = __importDefault(require("../CustomRepetitionType"));
const niceTime_1 = require("./niceTime");
const nth_1 = require("./nth");
function calcCustomRepetitionLabel(dueDate, customRepetition, short = false) {
    const { customRepetitionType, weekdays, datesOfMonth, last, weeksOfMonth, monthsOfYear } = customRepetition;
    const timeBit = (0, niceTime_1.niceTime)(dueDate);
    // Sort the weekdays, datesOfMonth, and months of year
    weekdays.sort((a, b) => a - b);
    datesOfMonth.sort((a, b) => a - b);
    monthsOfYear.sort((a, b) => a - b);
    const weekdaysStr = (0, commaJoin_1.default)(weekdays.map(d => moment_timezone_1.default.weekdays()[d]));
    const weekdayOfMonth = !!(weekdays === null || weekdays === void 0 ? void 0 : weekdays.length) ? weekdays === null || weekdays === void 0 ? void 0 : weekdays[0] : 1;
    const weekdayOfMonthStr = moment_timezone_1.default.weekdays()[weekdayOfMonth];
    const weekOfMonth = !!(weeksOfMonth === null || weeksOfMonth === void 0 ? void 0 : weeksOfMonth.length) ? weeksOfMonth[0] : 1;
    const weeksOfMonthStr = weekOfMonth > 0 ? (0, nth_1.nth)(weekOfMonth) : lib_i18n_1.default.t('last');
    const weekdaysOfMonth = `${(last ? `${lib_i18n_1.default.t('last')}` : '') + weeksOfMonthStr} ${weekdayOfMonthStr}`;
    const datesOfMonthStr = last ? lib_i18n_1.default.t('last-day') : (0, commaJoin_1.default)(datesOfMonth.map(d => (0, nth_1.nth)(d)));
    const monthsOfYearStr = (0, commaJoin_1.default)(monthsOfYear.map(v => moment_timezone_1.default.months(v - 1)));
    switch (customRepetitionType) {
        case CustomRepetitionType_1.default.WEEKLY:
            return short
                ? `${lib_i18n_1.default.t('weekly')} @ ${timeBit}`
                : `${lib_i18n_1.default.t('every')} ${weekdaysStr} @ ${timeBit}`;
        case CustomRepetitionType_1.default.MONTHLY:
            return short
                ? `${lib_i18n_1.default.t('monthly')} @ ${timeBit}`
                : `${lib_i18n_1.default.t('on-the-day-of-each-month', {
                    dayOfMonth: weekdaysOfMonth,
                })} @ ${timeBit}`;
        case CustomRepetitionType_1.default.MONTHLY_BY_DATE:
            return short
                ? `${lib_i18n_1.default.t('monthly')} @ ${timeBit}`
                : `${lib_i18n_1.default.t('on-the-day-of-each-month', {
                    dayOfMonth: datesOfMonthStr,
                })} @ ${timeBit}`;
        case CustomRepetitionType_1.default.YEARLY:
            return short
                ? `${lib_i18n_1.default.t('monthly')} @ ${timeBit}`
                : `${lib_i18n_1.default.t('on-the-monthday-of-each-year', {
                    dayOfMonth: weekdaysOfMonth,
                    monthOfYear: monthsOfYearStr,
                })} @ ${timeBit}`;
        case CustomRepetitionType_1.default.YEARLY_BY_DATE:
            return short
                ? `${lib_i18n_1.default.t('annually')} @ ${timeBit}`
                : `${lib_i18n_1.default.t('on-the-monthday-of-each-year', {
                    dayOfMonth: datesOfMonthStr,
                    monthOfYear: monthsOfYearStr,
                })} @ ${timeBit}`;
    }
}
exports.calcCustomRepetitionLabel = calcCustomRepetitionLabel;
exports.default = calcCustomRepetitionLabel;
